import { useTranslation } from 'react-i18next';

export const useWorkoutPlanCopy = () => {
    const { t } = useTranslation();

    return {
        header: 'Workouts',
        emptyState: {
            title: t('workout.plan.emptyState.title'),
            description: t('workout.plan.emptyState.description'),
        },
        planItem: {
            defaultPlanName: 'Main Exercise',
        },
    };
};
